// Admin-Modus der Buchungsstrecke: Der Admin bucht für einen Kunden (Telefon). Aktiviert über ?ab=<Token> (vom Admin-Bereich).
// Das Token liegt nur in dieser Browser-Sitzung (sessionStorage); der Server prüft es bei jeder Aktion erneut.
const KEY = "gt24_admin_booking";

export const getAdminToken = () => { try { return sessionStorage.getItem(KEY) || ""; } catch { return ""; } };
export const isAdminMode = () => !!getAdminToken();
export const getAdminFee = () => { try { const n = parseFloat(sessionStorage.getItem(`${KEY}_fee`) || "10"); return Number.isFinite(n) ? n : 10; } catch { return 10; } };
export const setAdminFee = (f) => { try { sessionStorage.setItem(`${KEY}_fee`, String(f)); } catch { /* ignorieren */ } };
export const clearAdminMode = () => { try { sessionStorage.removeItem(KEY); sessionStorage.removeItem(`${KEY}_fee`); } catch { /* ignorieren */ } };

// Beim Laden: Token aus der URL übernehmen und aus der Adresszeile entfernen
(function bootstrap() {
  try {
    const q = new URLSearchParams(window.location.search);
    const t = q.get("ab");
    if (!t) return;
    sessionStorage.setItem(KEY, t);
    q.delete("ab");
    const rest = q.toString();
    window.history.replaceState(null, "", window.location.pathname + (rest ? `?${rest}` : "") + window.location.hash);
  } catch { /* Storage nicht verfügbar */ }
})();
